import { render, staticRenderFns } from "./FormFields.vue?vue&type=template&id=05010f50&"
import script from "./FormFields.vue?vue&type=script&lang=js&"
export * from "./FormFields.vue?vue&type=script&lang=js&"
import style0 from "./FormFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports